module.exports = __webpack_public_path__ + "img/custom.3b2ab58d.png";